<template>
    <div class="spinner-div">
        <div class="spinner-border spinner-color"></div>
        <strong class="mt-2 spinner-color">Loading</strong>
    </div>
</template>
<style lang="css" scoped src="@/assets/css/loadingSpinner.css">
</style>
